import * as exConstants from './constants';

import exCardWidget from './cardWidget';

// ----------------------------------------------------------------------------

function init(): void {
    collapse();
    remove();
    maximize();
}

// ----------------------------------------------------------------------------

function collapse(): void {
    const elements = document.querySelectorAll<HTMLElement>(exConstants.SELECTOR_DATA_COLLAPSE);

    for (const element of elements) {
        element.addEventListener('click', (evt): any => {
            evt.preventDefault();
            const target = evt.target as HTMLElement;
            const data = new exCardWidget(target);
            data.toggle();
        });
    }
}

function remove(): void {
    const elements = document.querySelectorAll<HTMLElement>(exConstants.SELECTOR_DATA_REMOVE);

    for (const element of elements) {
        element.addEventListener('click', (evt): any => {
            evt.preventDefault();
            const target = evt.target as HTMLElement;
            const data = new exCardWidget(target);
            data.remove();
        });
    }
}

function maximize(): void {
    const elements = document.querySelectorAll<HTMLElement>(exConstants.SELECTOR_DATA_MAXIMIZE);

    for (const element of elements) {
        element.addEventListener('click', (evt): any => {
            evt.preventDefault();
            const target = evt.target as HTMLElement;
            const data = new exCardWidget(target);
            data.toggleMaximize();
        });
    }
}

// ----------------------------------------------------------------------------

export default init;
